import React, { useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Avatar, Button, Checkbox, Divider, FormControlLabel, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from 'react-router-dom';
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const BackGround=styled(Box)(({theme})=>({
   display:'flex',
   justifyContent:'center',
   alignItems:'center',
   padding:'30px',
   height:'100vh',
   width:'100vw',  
   background:theme.palette.secondary.lighter,
}))
const SignInCard=styled(Box)(({theme})=>({
    minWidth:'30%',
    minHeight:'40%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
}))
const Header=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:"15px",
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '15px',
}))

export default function Success() {
const navigate=useNavigate()
  return (
    <BackGround>
        <SignInCard>
             <LogoContainer >
                <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                <span>ASLMS</span>
            </LogoContainer>
            <Header>
                You have successfully completed the task!
            </Header>
              <Button
              type="submit"
              size="large"
              onClick={()=>navigate('/login')}
              sx={{
                   bgcolor:'secondary.main',
                   fontWeight: 400,
                   color:'#fff',
                   width:'100%',
                  "&:hover":{
                   bgcolor:'secondary.hover',}, } }
              >
                Sign In
              </Button>
            <Divider/>
        </SignInCard>
    </BackGround>
  )
}
